import React, { useState } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import ActiveGrid from './ActiveGrid'
import PendingGrid from './PendingGrid'
import CompletedGrid from './CompletedGrid'
import SampleDetails from './SampleDetails'
import { useAppContext } from 'hooks/useAppContext';
import AuthCheck from 'components/Shared/AuthCheck';

const tabs = [
  new Tab({ label: "Pending", value: "pending" }),
  new Tab({ label: "Active", value: "active" }),
  new Tab({ label: "Completed", value: "completed" })
]

// customFilter passed by Inspecitons to provide inspectionNumber to filter by. see FieldTests implementation
const Samples = ({ customFilter }) => {
  const [activeTab, setActiveTab] = useState("pending");
  const { currentModule, currentModuleFilter } = useAppContext(); //Getting the App Context

  return (
    <AuthCheck scope="Samples" action="read" showWarning={true}>
      <div>
        {
          (currentModule === "Samples" && currentModuleFilter != null) ? <SampleDetails sampleID={currentModuleFilter} /> :
            <TabbedPage
              tabs={tabs}
              activeTab={activeTab}
              tabSetterFunc={setActiveTab}
            >
              {(() => {
                switch (activeTab) {
                  case "pending": return <PendingGrid customFilter={customFilter} />
                  case "active": return <ActiveGrid customFilter={customFilter} />
                  case "completed": return <CompletedGrid customFilter={customFilter} />
                  default: return <PendingGrid />
                }
              })()}
            </TabbedPage>
        }
      </div>
    </AuthCheck>
  )
}

export default Samples;